import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

function onVariantUpdate(event) {
  const picker = event.target;
  if (!(picker instanceof HTMLElement) || picker.tagName.toLowerCase() !== 'variant-picker') return;

  const html = event.detail?.data?.html;
  if (!(html instanceof Document)) return;

  const section = picker.closest('[id^="shopify-section-"]');
  if (!(section instanceof HTMLElement) || !section.id) return;

  const newSection = html.getElementById(section.id);
  if (!(newSection instanceof HTMLElement)) return;

  for (const newRoot of newSection.querySelectorAll('[data-accordion-dimensions]')) {
    if (!(newRoot instanceof HTMLElement)) continue;
    const blockId = newRoot.dataset.accordionDimensions;
    if (!blockId) continue;

    const safeId = CSS.escape(blockId);
    const current = section.querySelector(`[data-accordion-dimensions="${safeId}"]`);
    if (current instanceof HTMLElement) {
      morph(current, newRoot);
    }
  }
}

document.addEventListener(ThemeEvents.variantUpdate, onVariantUpdate);
